import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
export const Stats = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].stats;
  return <FadeInSection className="w-full bg-white py-24 lg:py-32" data-id="element-256">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col items-center" data-id="element-257">
        <span className="eyebrow mb-4 text-center" data-id="element-258">{t.eyebrow}</span>
        <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-[#1a1a1a] mb-20 text-center" data-id="element-259">
          {t.headline}
        </h2>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-0" data-id="element-260">
          {t.items.map((item, index) => <div key={index} className={`flex flex-col items-center text-center ${index !== t.items.length - 1 ? 'lg:border-r border-[#c9a96e]/30' : ''}`} data-id="element-261">
              <span className="font-serif-display text-5xl md:text-[64px] text-[#c9a96e] mb-4" data-id="element-262">
                {item.num}
              </span>
              <span className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/70" data-id="element-263">
                {item.label}
              </span>
            </div>)}
        </div>
      </div>
    </FadeInSection>;
};